// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2DzZu","content":"LoadingAlert_content__1Hrkx"};